import axios, { AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { errorInterceptor } from './ErrorInterceptor';
import { sessionIdInterceptor } from './SessionID';
import { CustomerId, SiteId } from '../types';
import withJWTRefreshment from './TokenService/withJWTRefreshment';
import { injectTokenToConfig } from './TokenService/injectTokenToConfig';
import { retryCondition } from './retryCondition';
import { GcpRequestData } from '../store/uploadStore';

const STACK_PARAM = 'pilot';

class GcpRequestMeasurementsProcessorService {
  gcpRequestMeasurementsProcessorService: AxiosInstance;

  constructor() {
    this.gcpRequestMeasurementsProcessorService = withJWTRefreshment(
      axios.create({
        baseURL: GcpRequestMeasurementsProcessorUrl,
      }),
    );

    axiosRetry(this.gcpRequestMeasurementsProcessorService, {
      retries: Infinity,
      retryDelay: () => 1000,
      retryCondition,
    });

    this.gcpRequestMeasurementsProcessorService.interceptors.request.use((config) => sessionIdInterceptor(config));
    this.gcpRequestMeasurementsProcessorService.interceptors.response.use(
      (res) => res,
      (err) => errorInterceptor(err),
    );
  }

  async sendGcpRequest(
    customerId: CustomerId,
    siteId: SiteId,
    projectId: string | undefined,
    gcpRequest: GcpRequestData,
    scanId?: string,
    servicesPerformedOn?: string,
  ): Promise<void> {
    const config = await injectTokenToConfig(
      {},
      {
        customer: customerId,
        site: siteId,
      },
    );

    const res = await this.gcpRequestMeasurementsProcessorService.post(
      `customers/${customerId}/sites/${siteId}/gcp-request`,
      {
        gcpRequestServiceId: gcpRequest.airtableRecordId,
        flightMarkerData: gcpRequest.measurements,
        commentFromPilot: gcpRequest.comment,
        gcpServiceLaborTimeInHours: gcpRequest.gcpServiceLaborTimeInHours,
        flightMarkerImages: gcpRequest.photos,
        targetProjectId: projectId,
        stack: STACK_PARAM,
        scanId,
        servicesPerformedOn,
      },
      config,
    );

    return res.data;
  }
}

export default function getGcpRequestMeasurementsProcessorService() {
  return new GcpRequestMeasurementsProcessorService();
}
